export const MChatEnablementCodes = {
    MCHAT_CACHED_DISABLED: 'D_MChatCachedDisabled',
    MCHAT_STORE_NOT_READY: 'D_MChatStoreNotReady',
} as const;

export type MChatEnablementCode = typeof MChatEnablementCodes[keyof typeof MChatEnablementCodes];
